/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, tree: NonNullable<unknown> }} Unlock_Tree_Confirm_With_CoinsInputs */

const en_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.price} Coins to unlock ${i?.tree}?`)
};

const ar_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تريد استخدام ${i?.price} عملة لفتح ${i?.tree}؟`)
};

const de_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} Münzen verwenden, um ${i?.tree} freizuschalten?`)
};

const es_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Usar ${i?.price} Monedas para desbloquear ${i?.tree}?`)
};

const fr_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.price} Pièces pour débloquer ${i?.tree} ?`)
};

const it_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usare ${i?.price} Monete per sbloccare ${i?.tree}?`)
};

const ja_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}コインを使って${i?.tree}をアンロックしますか？`)
};

const ko_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} 코인을 사용하여 ${i?.tree}을(를) 잠금 해제할까요?`)
};

const pt_br_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.price} Moedas para desbloquear ${i?.tree}?`)
};

const ru_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Использовать ${i?.price} монет, чтобы разблокировать ${i?.tree}?`)
};

const th_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.price} เหรียญเพื่อปลดล็อก ${i?.tree} ไหม?`)
};

const tr_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tree} kilidini açmak için ${i?.price} Jeton kullanılsın mı?`)
};

const zh_cn_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 金币解锁 ${i?.tree}？`)
};

const zh_tw_unlock_tree_confirm_with_coins = /** @type {(inputs: Unlock_Tree_Confirm_With_CoinsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} 金幣解鎖 ${i?.tree}？`)
};

/**
* | output |
* | --- |
* | "Use {price} Coins to unlock {tree}?" |
*
* @param {Unlock_Tree_Confirm_With_CoinsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_tree_confirm_with_coins = /** @type {((inputs: Unlock_Tree_Confirm_With_CoinsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Tree_Confirm_With_CoinsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_tree_confirm_with_coins(inputs)
	if (locale === "ar") return ar_unlock_tree_confirm_with_coins(inputs)
	if (locale === "de") return de_unlock_tree_confirm_with_coins(inputs)
	if (locale === "es") return es_unlock_tree_confirm_with_coins(inputs)
	if (locale === "fr") return fr_unlock_tree_confirm_with_coins(inputs)
	if (locale === "it") return it_unlock_tree_confirm_with_coins(inputs)
	if (locale === "ja") return ja_unlock_tree_confirm_with_coins(inputs)
	if (locale === "ko") return ko_unlock_tree_confirm_with_coins(inputs)
	if (locale === "pt_br") return pt_br_unlock_tree_confirm_with_coins(inputs)
	if (locale === "ru") return ru_unlock_tree_confirm_with_coins(inputs)
	if (locale === "th") return th_unlock_tree_confirm_with_coins(inputs)
	if (locale === "tr") return tr_unlock_tree_confirm_with_coins(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_tree_confirm_with_coins(inputs)
	return zh_tw_unlock_tree_confirm_with_coins(inputs)
});